var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"title-box"},[_c('div',{staticClass:"title"},[_c('svg-icon',{staticClass:"icon",attrs:{"icon-class":_vm.title.icon}}),_c('span',[_vm._v(_vm._s(_vm.title.title))])],1)]),_c('div',{staticClass:"chart-box"},[_c('my-chart',{attrs:{"options":_vm.getPieOption(_vm.chartData),"id":_vm.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }